import request from "@/utils/request"

///获取策略配置记录
export function GetStrateAlarmParamPageList(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/CtrStrateAlarmParamCabinet/GetPageList",
    method: "post",
    data
  })
}
///add策略配置记录
export function AddStratealarmparam(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/CtrStrateAlarmParamCabinet/Add",
    method: "post",
    data
  })
}
///update策略配置记录
export function UpdateStratealarmparam(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/CtrStrateAlarmParamCabinet/Update",
    method: "post",
    data
  })
}
///delete策略配置记录
export function DeleteStratealarmparam(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/CtrStrateAlarmParamCabinet/Delete",
    method: "post",
    data
  })
}
